import React from 'react'
import Headerone from '../headerone/Main'
import About from '../menhome/About'
import Courses from '../menhome/Courses'
import Event from '../menhome/Event'
import Scholarship from '../menhome/Scholarship'
import Shep from '../menhome/Shep'
import Slider from '../menhome/Sliderone'
import SliderNew from '../menhome/SliderNew'
import Frequently from '../menhome/Frequently'
import Video from '../menhome/Video'
import Testimonial from '../menhome/Testimonial'
import Search from '../menhome/Search'
import Admission from '../menhome/Admission'
import Redslider from '../menhome/Redslider'
import Blog from '../menhome/Blog'
import Subscribe from '../menhome/Subscribe'
import Awards from '../menhome/Awards'
import News from '../menhome/News'
import Publications from '../menhome/Publications'


function Main() {
  return (
    <>  
        <Headerone/>
        <SliderNew/>
        
        {/* <Slider/> */}
        <News />
        <Event/>
        <About showVisionMission="yes" />
        <Awards/>
        <Scholarship/>

        {/* Director sir told to disable Publications from Home page and add in menus */}
        {/* <Publications /> */}

        {/* <Frequently/>
        <Video/>
        <Testimonial/>
        <Search/>
        <Admission/>
        <Redslider/>
        <Blog/>
        <Courses/>
        <Shep/>
        <Subscribe/> */}
    </>
  )
}

export default Main;